export default __webpack_public_path__ + "static/media/biomass-industrial-icon.d23f457a.svg";